export default "__VITE_ASSET__DxYE$2FK__"